import React, { useEffect } from 'react'
import {
  Grid,
  GridCell,
  Text,
  TEXT_VARIANT_BOLD,
  Flex,
  FlexItem,
  Switcher,
  Select,
  SELECT_VARIANT_WITH_CHECKBOX,
  ChipIconWrapper,
  ChipIconOpenNew,
  ChipIconTimes,
  Chip,
  SpacingVertical,
  Divider
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState
} from 'recoil'
import {
  searchCriteriaOptionsState,
  searchCriteriaState
} from '../recoil/states/searchCriteria'
import {
  MATCH_FILTER_CONDITION_ALL,
  MATCH_FILTER_CONDITION_AT_LEAST_ONE
} from 'Constants'
import { modalFilterDetailState } from '../recoil/states/page'
import { initSearchCriteriaCallback } from '../recoil/callbacks/callbacks'
import IncludeGroups from './IncludeGroups'
import ExcludeGroups from './ExcludeGroups'
import styled from '@emotion/styled'
import RecipientsSummary from './RecipientsSummary'

const StyledText = styled(Text)`
  position: relative;
  top: 8px;
`
const RecipientsSelectionGroupsTab = () => {
  const intl = useIntl()
  const [
    { loading, loaded, selectedFilters, typeAppliedFilters },
    setSearchCriteria
  ] = useRecoilState(searchCriteriaState)
  const { filters } = useRecoilValue(searchCriteriaOptionsState)
  const initSearchCriteria = useRecoilCallback(initSearchCriteriaCallback, [])

  useEffect(() => {
    !loaded && initSearchCriteria()
  }, [loaded])

  const handleChangeSwitcher = value => {
    setSearchCriteria(prev => ({
      ...prev,
      typeAppliedFilters: value,
      isNewSerach: true
    }))
  }

  const switcherOptions = [
    {
      label: intl.formatMessage({
        id: 'Load.SearchRecipients.filterAll'
      }),
      value: MATCH_FILTER_CONDITION_ALL,
      htmlAttrs: {
        'data-tip': intl.formatMessage({
          id: 'Load.SearchRecipients.filterAllTooltip'
        })
      }
    },
    {
      label: intl.formatMessage({
        id: 'Load.SearchRecipients.filterOne'
      }),
      value: MATCH_FILTER_CONDITION_AT_LEAST_ONE,
      htmlAttrs: {
        'data-tip': intl.formatMessage({
          id: 'Load.SearchRecipients.filterOneTooltip'
        })
      }
    }
  ]

  const handleFiltersChange = value => {
    setSearchCriteria(prev => ({
      ...prev,
      selectedFilters: value,
      isNewSerach: true
    }))
  }

  const SelectedItemComponent = ({ label, value, onClick, ...props }) => {
    const setModal = useSetRecoilState(modalFilterDetailState)
    return (
      <Chip label={label} value={value}>
        <ChipIconWrapper
          onClick={e => setModal({ show: true, ...props, id: value })}
          data-mu-test='lpemail-sending-w__additional-group__show'
        >
          <ChipIconOpenNew />
        </ChipIconWrapper>
        <ChipIconWrapper
          onClick={e => onClick(value, e)}
          data-mu-test='lpemail-sending-w__additional-group__remove'
        >
          <ChipIconTimes />
        </ChipIconWrapper>
      </Chip>
    )
  }

  return (
    <>
      <Grid cols={12}>
        <GridCell span={2}>
          <StyledText variant={TEXT_VARIANT_BOLD}>
            {intl.formatMessage({
              id: 'Load.Rcs.RecipientsSelectionGroupsInclude'
            })}
          </StyledText>
        </GridCell>
        <GridCell span={10}>
          <IncludeGroups />
        </GridCell>

        <GridCell span={2}>
          <StyledText variant={TEXT_VARIANT_BOLD}>
            {intl.formatMessage({
              id: 'Load.Rcs.RecipientsSelectionGroupsExclude'
            })}
          </StyledText>
        </GridCell>
        <GridCell span={10}>
          <ExcludeGroups />
        </GridCell>

        <GridCell span={2}>
          <StyledText variant={TEXT_VARIANT_BOLD}>
            {intl.formatMessage({
              id: 'Load.Rcs.RecipientsSelectionFilters'
            })}
          </StyledText>
        </GridCell>
        <GridCell span={10}>
          <Flex
            width='100%'
            alignItems='flex-start'
            flexWrap='no-wrap'
            columnGap='32px'
          >
            {selectedFilters.length > 1 && (
              <FlexItem width='auto' alignSelf='flex-start' margin='0 -8px'>
                <Switcher
                  value={typeAppliedFilters}
                  onChange={handleChangeSwitcher}
                  options={switcherOptions}
                />
              </FlexItem>
            )}
            <FlexItem width='100%'>
              <Select
                multiple
                searchable
                variant={SELECT_VARIANT_WITH_CHECKBOX}
                loading={loading}
                placeholder={intl.formatMessage({
                  id: 'Load.Rcs.RecipientsSelectionGroupsFiltersPlaceholder'
                })}
                options={filters.options}
                optionGroups={filters.optionGroups}
                value={selectedFilters}
                onChange={handleFiltersChange}
                SelectedItemComponent={SelectedItemComponent}
                selectedFilters={selectedFilters}
              />
            </FlexItem>
          </Flex>
        </GridCell>
      </Grid>
      <SpacingVertical />
      <Divider />
      <SpacingVertical />
      <RecipientsSummary />
    </>
  )
}

export default RecipientsSelectionGroupsTab
